/**
 * Download a clinic operations report as PDF
 * @param {string} clinicId - The clinic UUID
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 * @returns {Promise<Blob>} - PDF file blob
 */
export const downloadClinicReport = async (clinicId, startDate, endDate) => {
  const token = localStorage.getItem("access_token");
  const backendUrl = process.env.REACT_APP_BACKEND_BASE_URL;

  const params = new URLSearchParams();
  params.append("start_date", startDate);
  params.append("end_date", endDate);

  const endpoint = `/reports/clinic/${clinicId}/operations?${params.toString()}`;

  const response = await fetch(`${backendUrl}${endpoint}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage = "Failed to generate report";
    try {
      const errorJson = JSON.parse(errorText);
      errorMessage = errorJson.message || errorMessage;
    } catch {
      errorMessage = errorText || errorMessage;
    }
    throw new Error(errorMessage);
  }

  return response.blob();
};

/**
 * Download clinic report and trigger file download
 * @param {string} clinicId - The clinic UUID
 * @param {string} clinicName - The clinic name (for filename)
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 */
export const downloadAndSaveClinicReport = async (
  clinicId,
  clinicName,
  startDate,
  endDate
) => {
  const blob = await downloadClinicReport(clinicId, startDate, endDate);

  // Create filename
  const safeName = clinicName.replace(/[^a-zA-Z0-9]/g, "_");
  const filename = `${safeName}_Operations_Report_${startDate}_to_${endDate}.pdf`;

  // Trigger download
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
